import React from 'react';

import fetch from './fetch';

import moment from 'moment';

import utils from './../utils';

import {Modal, message,Tag} from 'antd';
// import 'antd/lib/tag/style/css/index.css';

const DataGrid = {
    selections: [],
    refresh: function() {

    }
}

const columns = utils.columns([
    {key:'$index', label: '序号'},
    {key:'orgName', label: '部门名称'},
    {key:'courseName', label: '课程名称'},
    {key:'evalName', label: '评价方'},
    {key:'finalScore', label: '平均分'},
    {key:'descText', label: '描述'},
    {key:'status', label: '状态',render:(value) =>{
        if(value === '预警状态'){
        return  <span style={{textAlign:"center",display:"block"}}><Tag color="#f50" >{value}</Tag></span>
        }else{
            return  <span style={{textAlign:"center",display:"block"}}><Tag color="#108ee9">{value}</Tag></span>
        }
    }},
]);


/**
 * @method querySearch
 * @param {object} [keywords]
 * @return {promise}
 */
const querySearch = (keywords = {pageNum: 1, pageSize: 100}) => {
    var params = [];
    var newKeyword = {};
    const session = JSON.parse(sessionStorage.session || '{"account": {}}')
    const account = session.account;

    const defaultsParams = {
        bgTermId: account.termId,
        endTermId: account.termId
    };
    for(var i in keywords) {
        if(i === 'pageSize'){
            params.push(`pageSize=${keywords[i]}`);
        } else if(i === 'pageNum'){
            params.push(`pageNum=${keywords[i]}`);
        } else if(i === 'sort'){
            params.push(`sort=${keywords[i]}`);
        }  else if(i === 'order'){
            params.push(`order=${keywords[i]}`);
        } else {
            newKeyword[i] = keywords[i];
        }
    }

    return fetch.post('earlywarning/query?'+ params.join('&'), Object.assign({
        type: "course"
    }, defaultsParams, newKeyword))
    .then(response => {
        return response.payload.data;
    })
    .then(data => (Object.assign({
        result: data.dataList || [],
        selects: (data.dataList || []).map((d, i) => ({
            value: d,
            checked: false
        })),
        checked: false,
        total: data.total,
        pageIndex: data.pageNum,
        pageSize: data.pageSize,
        notify: (data.dataList || []).length ? '' : '暂无数据...'
    })));
}

/**
 * @method onSelect
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const onSelect = (ids) => {
    DataGrid.selections = ids;
}

const getSelection = () => {
    return DataGrid.selections;
}

/**
 * @method setRefresh
 * @param {function} callback
 * @return {promise}
 */
const setRefresh = (callback) => {
    DataGrid.refresh = callback;
};

/**
 * @method redirect
 * @param {string} url
 * @return {void}
 */
const redirect = (url) => {
    window.location.hash = 'earlywarning'+ url;
};

export default {
    querySearch,
    columns,
    onSelect,
    setRefresh,
    redirect,
    getSelection
}